export type DqxRunOutcome = "running" | "success" | "failure";

/** Whether the Databricks-style run has finished successfully, failed, or is still in progress. */
export function classifyDqxRunStatus(status: {
  lifeCycleState: string;
  resultState: string | null;
}): DqxRunOutcome {
  const rs = (status.resultState ?? "").trim().toUpperCase();
  const lc = (status.lifeCycleState ?? "").trim().toUpperCase();

  if (lc === "TERMINATED") {
    return rs === "SUCCESS" ? "success" : "failure";
  }
  if (lc === "INTERNAL_ERROR" || lc === "SKIPPED") return "failure";
  if (["FAILED", "TIMEDOUT", "CANCELED", "ERROR"].includes(rs)) return "failure";
  if (rs === "SUCCESS") return "success";

  return "running";
}
